import { render, staticRenderFns } from "./ConfirmLeaveDialog.vue?vue&type=template&id=13a52dcc&"
import script from "./ConfirmLeaveDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmLeaveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports